export default "__VITE_ASSET__BjSpENMJ__"